import axios from "../../axiosClient";

export const getGatewayGroup = async (
  gatewayCode: string,
  PageNumber: any = 0,
  pageSize: any = 0,
) => {
  if (!gatewayCode) return;
  const res = await axios.get(`/slpapp/GatewayGroup`, {
    params: { gatewayCode, PageNumber, pageSize },
  });

  return res?.data;
};

export const getGroupUnAckInfoByGateway = async (
  gatewayCode: any,
  groupId:any,
  PageNumber: any,
  PageSize: any,
  SortBy: any,
  SortDirection: any,
  SearchText: any,
) => {
  if (!gatewayCode) return;
  const res = await axios.post(
    `/slpapp/GatewayGroup/GetGroupUnAckInfoByGateway`,
    null,
    {
      params: {
        gatewayCode,
        groupId,
        PageNumber,
        SortBy,
        SortDirection,
        PageSize,
        SearchText,
      },
    },
  );

  return res?.data;
};
